import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function VolumeOffSolidIcon(props, ref) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.5 3.5a1 1 0 1 0-1.414 1.414L5.172 8H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2l3.293 3.293c.63.63 1.707.184 1.707-.707v-3.758l7.086 7.086A1 1 0 0 0 20.5 20.5l-2.136-2.136.003-.003-1.414-1.414-.003.003-1.414-1.414.003-.003-1.415-1.415-.002.003L12 12v-.006L7.503 7.497 7.5 7.5l-4-4Zm11.496 8.662 1.661 1.66c.222-.564.343-1.18.343-1.822 0-1.38-.56-2.632-1.464-3.536a1 1 0 1 0-1.414 1.414 2.987 2.987 0 0 1 .874 2.284Zm3.164 3.164 1.462 1.462A8.961 8.961 0 0 0 21 12a8.975 8.975 0 0 0-2.636-6.364A1 1 0 0 0 16.95 7.05 6.975 6.975 0 0 1 19 12a6.966 6.966 0 0 1-.84 3.326ZM8.917 6.083 12 9.166V5.414c0-.89-1.077-1.337-1.707-.707L8.917 6.083Z"
    })
  });
}
;
VolumeOffSolidIcon.displayName = "VolumeOffSolidIcon";
export default forwardRef(VolumeOffSolidIcon);